var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedeemBenefit1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 103,
    viewBox: "0 0 103 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.5 101.679C79.2811 101.679 102 78.9598 102 51.1787C102 23.3533 79.2811 0.678711 51.5 0.678711C23.6746 0.678711 1 23.3549 1 51.1787C1 78.9598 23.6761 101.679 51.5 101.679Z",
    fill: "#393E45",
    stroke: "black",
    strokeWidth: 1.00301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.8999 27.4644C80.4967 28.1575 81.318 27.5942 82.9637 29.4978C85.5162 32.3968 85.5162 36.7675 84.7819 39.3643C83.3972 44.5578 77.0359 49.7497 71.9721 48.4079C66.9084 47.0232 64.8322 40.2726 65.8276 35.0791C65.8703 34.8196 65.9146 34.56 66.0001 34.3433C67.3847 29.1513 72.7064 26.0355 77.8999 27.4644ZM66.5619 50.6153C68.5098 53.9479 72.7935 55.1157 76.126 53.2121L78.3335 51.9145L79.5456 52.2167C82.7912 53.0823 83.7865 52.5633 85.3009 54.5097C87.2488 57.0622 86.9451 60.3947 86.339 62.732L83.6995 72.5114L76.4298 70.5634L57.7793 65.5867L50.3799 63.596L52.9766 53.8166C54.491 48.2338 58.5151 46.5897 64.0979 48.1041L65.3101 48.4063L66.5619 50.6153Z",
    fill: "#AE7911",
    stroke: "#171819",
    strokeWidth: 1.00301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4458 54.0771L12.5561 44.8167C11.9501 43.6046 12.0371 41.1819 13.379 39.2782L34.6262 30.6239C35.8811 30.1049 37.3085 30.4941 37.9588 31.7063L42.7615 41.1834L43.2378 42.0917L44.4499 42.2215L36.3574 55.7655L17.4458 54.0771Z",
    fill: "#27282B",
    stroke: "#171819",
    strokeWidth: 1.00301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.5718 42.3499L50.115 51.3508L55.3085 58.4907C55.6108 59.0967 54.7895 61.779 54.1407 62.0828L40.9859 68.7907L27.8312 75.4985C27.5289 75.6283 27.1381 75.6711 26.8359 75.5413C26.5336 75.4543 26.2298 75.239 26.0573 74.8925L17.0977 57.5823L17.4442 54.0773L36.3542 55.7657L44.4467 42.2217L45.5718 42.3499Z",
    fill: "#AE7911",
    stroke: "#171819",
    strokeWidth: 1.00301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.0924 39.4941L50.6356 48.495L55.223 57.4531C55.3955 57.7996 55.3955 58.1462 55.3101 58.4912C55.223 58.7934 54.9635 59.0545 54.6612 59.227L41.5065 65.9349L28.3518 72.5985C28.0495 72.771 27.703 72.771 27.3564 72.6855C27.0542 72.5985 26.7504 72.3833 26.6206 72.0367L17.4473 54.0778L34.8002 55.6349C35.7528 55.7219 36.6611 55.2884 37.1374 54.4228L46.0924 39.4941Z",
    fill: "#FFC74E",
    stroke: "#171819",
    strokeWidth: 1.00301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.0901 39.4936L26.9205 37.2861L19.7363 54.2925L34.7963 55.6344C35.7489 55.7214 36.6572 55.2878 37.1335 54.4222L46.0901 39.4936Z",
    fill: "#FFC74E",
    stroke: "#171819",
    strokeWidth: 1.00301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8456 55.5479L27.3545 72.6855",
    stroke: "#171819",
    strokeWidth: 1.00301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7393 53.4268L55.3089 58.4905",
    stroke: "#171819",
    strokeWidth: 1.00301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7355 54.2927L34.7954 55.6346C35.748 55.7216 36.6563 55.2881 37.1326 54.4225L44.9213 41.483L38.473 28.8031C37.8242 27.5909 36.3525 27.1146 35.1404 27.7207L14.3695 38.2817C13.1573 38.9305 12.681 40.4022 13.2871 41.6143L19.7355 54.2927Z",
    fill: "#595E65",
    stroke: "#171819",
    strokeWidth: 1.00301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1959 34.2147C34.6233 34.691 35.7057 35.6864 36.3545 36.9413C37.0033 38.1961 37.133 39.6678 36.701 41.0951L36.0079 43.2156C35.8782 43.5179 35.5316 43.6919 35.2294 43.6049L33.715 43.0858C33.4127 42.9988 33.1959 42.6538 33.3257 42.35L34.0188 40.2296C34.2356 39.5365 34.1485 38.8022 33.8463 38.1961C33.544 37.5901 33.0234 37.1138 32.3319 36.8985C31.6388 36.6817 30.9045 36.726 30.2985 37.071C29.6924 37.3733 29.2161 37.8939 29.0008 38.5854L28.3078 40.7059C28.2207 41.0081 27.8757 41.1822 27.5292 41.0951L26.0148 40.6188C25.7125 40.4891 25.5385 40.1425 25.6255 39.8403L26.3186 37.7198C26.7949 36.2924 27.7902 35.1673 29.0451 34.5613C30.2969 33.9109 31.767 33.7384 33.1959 34.2147ZM32.6769 39.0602C32.5044 38.7136 32.2006 38.4541 31.8541 38.3244C31.4648 38.2373 31.0755 38.2816 30.7717 38.4114C30.4694 38.5839 30.2084 38.8877 30.0786 39.2342L27.8712 45.9848C27.7414 46.3741 27.7841 46.7634 27.9582 47.0672C28.1307 47.4137 28.3902 47.6733 28.781 47.7603C29.1275 47.89 29.5168 47.8473 29.8634 47.6733C30.1656 47.5435 30.4267 47.2412 30.5564 46.8504L32.7639 40.0998C32.8494 39.7533 32.8067 39.364 32.6769 39.0602ZM35.0126 46.2871L34.3195 48.4076C33.8432 49.8349 32.8479 50.9173 31.593 51.5661C30.3381 52.2149 28.8665 52.3447 27.4391 51.9126C26.0118 51.4363 24.8866 50.441 24.2806 49.1861C23.6318 47.9313 23.4577 46.4596 23.934 45.0322L24.6271 42.9118C24.7141 42.5653 25.0592 42.3927 25.4057 42.5225L26.9201 42.9988C27.2223 43.1286 27.3964 43.4751 27.3094 43.7774L26.6163 45.8978C26.3995 46.5909 26.4438 47.2825 26.7888 47.8885C27.0911 48.4946 27.6116 49.0136 28.3032 49.2304C28.9963 49.4472 29.6878 49.3602 30.2939 49.0579C30.8999 48.7556 31.419 48.2351 31.6358 47.5435L32.3288 45.4231C32.4158 45.0765 32.7609 44.904 33.1074 45.0338L34.6218 45.5101C34.9271 45.5956 35.0996 45.9421 35.0126 46.2871Z",
    fill: "#FFC74E",
    stroke: "#171819",
    strokeWidth: 1.00301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3524 72.6855L27.2227 75.6273",
    stroke: "#171819",
    strokeWidth: 1.00301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4104 60.3945L52.2363 63.3378",
    stroke: "#171819",
    strokeWidth: 1.00301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8959 42.7822L13.6807 46.8934",
    stroke: "#171819",
    strokeWidth: 1.00301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.2261 45.5958L64.4382 45.8981L65.693 48.1483C67.641 51.4808 71.9246 52.6059 75.2572 50.7007L77.4647 49.4031L78.6768 49.7497C84.2596 51.2213 86.9418 54.6394 85.4702 60.2222L82.8307 70.0458L49.4668 61.0877L52.1063 51.3083C53.6192 45.7256 57.6448 44.0814 63.2261 45.5958Z",
    fill: "#FFC74E",
    stroke: "#171819",
    strokeWidth: 1.00301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.0344 24.953C71.8409 23.5684 66.5191 26.6414 65.1345 31.8334C63.7071 37.0269 66.1299 44.9026 71.3234 46.2873C76.5169 47.6719 82.5317 42.0464 83.9163 36.8529C85.2994 31.6609 82.2264 26.3392 77.0344 24.953Z",
    fill: "#FFC74E",
    stroke: "#171819",
    strokeWidth: 1.00301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.96 32.5696C70.5855 33.9115 74.4371 34.5176 79.4566 31.6613C79.4566 31.6613 80.1497 34.7771 83.9143 36.8548C85.2989 31.6613 82.2258 26.3396 77.0339 24.955C71.8404 23.5703 66.5186 26.6434 65.134 31.8354C65.047 32.0949 65.0042 32.3101 64.96 32.5696Z",
    fill: "#595E65",
    stroke: "#171819",
    strokeWidth: 1.00301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9082 63.0782L59.3737 53.9033",
    stroke: "#171819",
    strokeWidth: 1.00301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5625 68.0977L78.0295 58.9229",
    stroke: "#171819",
    strokeWidth: 1.00301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8311 70.0439L83.6966 72.5109",
    stroke: "#171819",
    strokeWidth: 1.00301,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5625 68.0977L76.4281 70.5646",
    stroke: "#171819",
    strokeWidth: 1.00301,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9131 36.8545C83.9131 36.8545 84.6489 39.407 84.0428 41.3122",
    stroke: "black",
    strokeWidth: 1.00301,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.9116 36.8547C83.9116 36.8547 84.6474 39.4072 84.0413 41.3124C84.3879 40.6636 84.6047 40.0148 84.7772 39.3645C85.513 36.7677 85.513 32.3971 82.959 29.498C84.2139 31.6612 84.6031 34.258 83.9116 36.8547Z",
    fill: "#595E65",
    stroke: "#171819",
    strokeWidth: 1.00301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.3653 62.2549C45.9169 62.2549 40.6807 67.4911 40.6807 73.9395C40.6807 80.3879 45.9169 85.6241 52.3653 85.6241C58.8136 85.6241 64.0499 80.3879 64.0499 73.9395C64.0499 67.4911 58.8136 62.2549 52.3653 62.2549Z",
    fill: "#144028",
    stroke: "#171819",
    strokeWidth: 1.00301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.3653 59.4863C45.9169 59.4863 40.6807 64.7226 40.6807 71.1709C40.6807 77.6193 45.9169 82.8555 52.3653 82.8555C58.8136 82.8555 64.0499 77.6193 64.0499 71.1709C64.0499 64.7226 58.8136 59.4863 52.3653 59.4863Z",
    fill: "#298552",
    stroke: "#171819",
    strokeWidth: 1.00301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.5784 63.7695H51.1556C50.4198 63.7695 49.8138 64.3756 49.8138 65.1114V68.6165H46.3087C45.5729 68.6165 44.9668 69.2226 44.9668 69.9584V72.3811C44.9668 73.1169 45.5729 73.723 46.3087 73.723H49.8138V77.2281C49.8138 77.9639 50.4198 78.5699 51.1556 78.5699H53.5784C54.3142 78.5699 54.9202 77.9639 54.9202 77.2281V73.723H58.4253C59.1611 73.723 59.7672 73.1169 59.7672 72.3811V69.9584C59.7672 69.2226 59.1611 68.6165 58.4253 68.6165H54.9202V65.1114C54.9202 64.3756 54.3142 63.7695 53.5784 63.7695Z",
    fill: "#144028",
    stroke: "#171819",
    strokeWidth: 1.00301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M47.692 81.8584L47.5195 84.1514",
    stroke: "#171819",
    strokeWidth: 1.00301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.2571 21.0587C38.8204 20.4969 39.1226 20.2801 39.7715 19.7611C42.4537 17.6833 46.0901 16.0392 49.8547 15.4774C53.749 14.8713 57.7731 15.3476 61.1485 17.5979C62.2736 18.3337 63.3117 19.2863 64.2215 20.4541L66.3847 17.9017C66.5572 17.7291 67.3801 20.0221 67.1205 20.7152L64.6535 26.9895C64.5238 27.2918 64.1772 27.4215 63.875 27.249L58.509 23.6569C57.9029 23.2677 57.3411 21.0174 57.5564 21.0602L60.2829 21.796C59.8509 21.4067 59.4173 21.0602 58.9853 20.7579C56.4328 19.0695 53.317 18.6802 50.2867 19.1565C47.1709 19.6756 44.1421 21.0174 41.9774 22.6616C41.4583 23.0936 40.982 23.4844 40.55 23.9165C39.944 24.5225 39.0356 24.6095 38.2998 24.176L37.6067 23.7867C37.1304 23.5272 37.0877 21.2342 37.0434 20.7137C37.0022 20.1503 37.8678 21.4479 38.2571 21.0587Z",
    fill: "#27282B",
    stroke: "#171819",
    strokeWidth: 1.00301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5249 19.3273C38.0439 18.764 38.65 18.2449 39.2988 17.7259C41.8955 15.6482 45.4433 14.004 49.2079 13.4422C53.0153 12.8362 57.0837 13.3125 60.546 15.5627C61.8436 16.3855 63.0557 17.4664 64.1381 18.851L61.1948 21.144C60.4163 20.1486 59.5064 19.3258 58.5126 18.7212C55.9158 17.0328 52.8 16.6435 49.7713 17.1198C46.6555 17.6389 43.7122 18.9808 41.5932 20.6249C41.1169 21.0569 40.6406 21.4478 40.2514 21.8798C39.688 22.4858 38.737 22.6156 38.0012 22.1393L37.8286 22.0523C37.3966 21.75 37.0928 21.3165 37.0501 20.7547C36.9615 20.2372 37.134 19.7609 37.5249 19.3273Z",
    fill: "#595E65",
    stroke: "#171819",
    strokeWidth: 1.00301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.1649 21.6222L63.7477 25.2143C64.05 25.3868 64.3537 25.257 64.4835 24.9547L66.6467 18.6804C66.7337 18.4636 66.6894 18.1614 66.5169 17.9018C66.3444 17.6851 66.1277 17.5996 65.8681 17.6851L58.1649 20.3245C57.9481 20.4116 57.8184 20.6268 57.8184 20.9306C57.8184 21.1886 57.9481 21.4481 58.1649 21.6222Z",
    fill: "#595E65",
    stroke: "#171819",
    strokeWidth: 1.00301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedeemBenefit1);
export default __webpack_public_path__ + "static/media/redeem-benefit-1.0f08ecffb72ac7fa70f0794e5ce7e703.svg";
export { ForwardRef as ReactComponent };